// extracted by mini-css-extract-plugin
export default {"titleAndCover":"album-cover_titleAndCover__oLDwr","cover":"album-cover_cover__hha2H","fileUploader":"album-cover_fileUploader__iGNPF"};